import React from 'react';
import { useTranslation } from 'react-i18next';

import ProjectInfoPanel from 'components/ProjectInfoPanel/ProjectInfoPanel';

import './AuctionDates.scss';
import useFormattedDate, { FULL_MONTH_WITH_TIME_AND_TIMEZONE } from '../../../../hooks/useFormattedDate';
import { useSelector } from '../../../../store';

export interface AuctionDatesProps {}

const AuctionDates = ({}: AuctionDatesProps) => {
  const { t } = useTranslation();
  const rfp = useSelector((state) => state.rfp.data);

  const openDate = useFormattedDate(rfp.open_date ?? '', FULL_MONTH_WITH_TIME_AND_TIMEZONE);
  const closeDate = useFormattedDate(rfp.response_close_date, FULL_MONTH_WITH_TIME_AND_TIMEZONE);

  return (
    <section className="enkrateia-prosfora-auction-dates">
      <ProjectInfoPanel variant="prosfora" label={t('pages.prosforaProject.openDate')} value={openDate} />
      <ProjectInfoPanel variant="prosfora" label={t('pages.prosforaProject.closeDate')} value={closeDate} />
    </section>
  );
};

export default AuctionDates;
